<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="tiles">
    <svg:g *ngFor="let tile of tiles" class="tile-group"
           container="body" ngbPopover="{{tile.text}}" triggers="mouseenter:mouseleave"
           popoverTitle="{{tile.label}}">
        <svg:rect class="rect" rx="2"
                  [attr.x]="tile.x" [attr.y]="tile.y"
                  [attr.width]="tile.width" [attr.height]="tile.height"
                  [attr.fill]="tile.fill" fill-opacity="0.88"></svg:rect>
        <!-- Tile ink is white over the saturated fills; small tiles get no text (tooltip only). -->
        <svg:text *ngIf="tile.displayLabel"
                  [attr.x]="tile.x + 6" [attr.y]="tile.y + 15"
                  fill="#fff" font-size="11" font-weight="600"
                  style="pointer-events: none">{{tile.displayLabel}}</svg:text>
        <svg:text *ngIf="tile.displayValue"
                  [attr.x]="tile.x + 6" [attr.y]="tile.y + 29"
                  fill="#fff" fill-opacity="0.85" font-size="10"
                  style="pointer-events: none">{{tile.displayValue}}</svg:text>
    </svg:g>
</svg:g>
